import { Box, LoadingOverlay } from '@mantine/core'
import { useMutation } from '@tanstack/react-query'
import { useIntl } from 'react-intl'
import { accountApi } from '@/api/accountApi'
import { extractErrorMessage } from '@/api/helpers/extractErrorMessage'
import { AuthLayout } from '@/components/layout/AuthLayout/AuthLayout'
import { showToast } from '@/theme/notifications'
import { PasswordResetLinkExpired } from './PasswordResetLinkExpired/PasswordResetLinkExpired'

type LinkExpiredHandlerProps = {
  uid: string
}

export const LinkExpiredHandler = ({ uid }: LinkExpiredHandlerProps) => {
  const intl = useIntl()

  const { mutate, isPending } = useMutation({
    mutationFn: accountApi.sendPasswordResetEmail,
    onSuccess: () => {
      showToast(intl.formatMessage({ id: 'emailSent' }), 'success')
    },
    onError: (err) => {
      showToast(
        extractErrorMessage(
          err,
          intl.formatMessage({ id: 'emailFailedToSend' })
        ),
        'error'
      )
    }
  })

  const handleResendEmail = () => {
    if (!isPending) {
      mutate({ uid })
    }
  }

  return (
    <AuthLayout variant="large">
      <Box>
        <LoadingOverlay visible={isPending} />

        <PasswordResetLinkExpired onResendEmail={handleResendEmail} />
      </Box>
    </AuthLayout>
  )
}
